import * as React from "react";
const SvgError24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 22,
        fill: "black",
        viewBox: "0 0 24 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m.345 11 .289-.5 5.25-9.093.289-.5h11.654l.289.5 5.25 9.093.289.5-.29.5-5.25 9.093-.288.5H6.173l-.29-.5L.634 11.5.346 11Zm2.31 0 4.672 8.093h9.346L21.345 11l-4.672-8.093H7.327L2.655 11Zm7.93 0L7.294 7.707l1.414-1.414L12 9.586l3.293-3.293 1.414 1.414L13.414 11l3.293 3.293-1.414 1.414L12 12.414l-3.293 3.293-1.414-1.414L10.586 11Z",
      clipRule: "evenodd"
    })
  );
export default SvgError24Px;
